import { Navigate, useLocation } from 'react-router-dom';

export const LayoutRedirector = () => {
  const location = useLocation();

  const search =
    location.pathname
      .split('/')
      .pop()
      ?.replace(/\.html$/, '')
      .match(/\b\w{2,}\b/g)
      ?.slice(1)
      ?.join(' ') ?? '';

  return <Navigate to={`/ingredients/search?query=${search}`} />;
};
